'use strict'

const state = {
  latestMenuList: [],
  cachedComponentList: [],
  current: 0
}

const getters = {
  getLatestMenuList (state) {
    return state.latestMenuList.slice().reverse()
  },
  getCurrent (state) {
    //return (state.latestMenuList.length - 1) - state.current
    return state.current
  },
  getCachedComponentList (state) {
    return state.cachedComponentList
  }
}

const mutations = {
  setLatestMenuList (state, { latestMenuList }) {
    state.latestMenuList = latestMenuList
  },
  setCurrent (state, { current }) {
    state.current = current
  },
  setCachedComponentList (state, { cachedComponentList }) {
    state.cachedComponentList = cachedComponentList
  },  
  addCachedComponentList (state, { cachedComponent }) {
    state.cachedComponentList.push(cachedComponent)
  }
}

const actions = {
  insertLatestMenu ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      var latestMenu = {
        name : params.name,
        desc : params.desc
      }

      var exist = _.findIndex(state.latestMenuList, function(o) { return o.name == params.name; });

      if (exist > -1) {
        state.current = (state.latestMenuList.length - 1) - exist;
      } else {
        if (state.latestMenuList.length >= 5) {
          state.latestMenuList.splice(0, 1)
          state.cachedComponentList.splice(0, 1)
        }
  
        state.latestMenuList.push(latestMenu)
        state.cachedComponentList.push(latestMenu.name)
        state.current = 0
      }

      resolve()
    })
  },
  deleteLatestMenu ({ commit, state }, params) {
    return new Promise((resolve, reject) => {

      var exist = _.findIndex(state.latestMenuList, function(o) { return o.name == params.name; });

      if (exist > -1) {
        // alert(JSON.stringify(state.latestMenuList));
        for(var i in state.latestMenuList) {
          if(state.latestMenuList[i].name == params.name) {
            state.latestMenuList.splice(i, 1)
            state.cachedComponentList.splice(i, 1)
          }
        }

        if ( exist > state.current ) {
          state.current = (state.current - 1) < 0 ? 0 : state.current - 1;
        }
      }
      
      resolve()
    })
  },
  moveLatestMenu ({ commit, state }, params) {
    return new Promise((resolve, reject) => {    
      var index = (state.latestMenuList.length - 1) - state.current

      if (params.type == 'left') {
        if (state.current > 0) {
          state.current--
          var latestMenu = state.latestMenuList.splice(index, 1)
          state.latestMenuList.splice(index + 1, 0, latestMenu[0])
          state.cachedComponentList.splice(index + 1, 0, latestMenu[0].name)
        }
      } else {
        if ((state.latestMenuList.length - 1) > state.current) {
          state.current++
          var latestMenu = state.latestMenuList.splice(index, 1)
          state.latestMenuList.splice(index - 1, 0, latestMenu[0])
          state.cachedComponentList.splice(index - 1, 0, latestMenu[0].name)
        }
      }

      resolve()
    })      
  },
  clearLatestMenu ({ commit, state }) {  
    return new Promise((resolve, reject) => {
      state.latestMenuList = [];
      state.cachedComponentList = [];
      state.current = 0;
      
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/stores/modules/LatestMenu.js